function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30.7955 13.0388V20.3907H24.8478V13.0388C24.8478 9.12783 21.6668 5.94768 17.7574 5.94768H17.7566C13.8456 5.94848 10.6655 9.12783 10.6655 13.0388V20.3907H4.71777V13.0388C4.71777 5.84853 10.5663 0.000799635 17.7566 0H17.7574C24.9461 0 30.7955 5.84853 30.7955 13.0388Z",
  fill: "#B0C9FA"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7956 13.0388V20.3907H24.8479V13.0388C24.8479 9.12783 21.6669 5.94768 17.7575 5.94768H17.7567V0H17.7575C24.9462 0 30.7956 5.84853 30.7956 13.0388Z",
  fill: "#397CFE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5134 20.6012V38.2331C35.5134 39.6413 34.3723 40.7824 32.965 40.7824H2.54844C1.14108 40.7824 0 39.6413 0 38.2331V20.6012C0 19.1938 1.14108 18.0527 2.54844 18.0527H32.965C34.3723 18.0527 35.5134 19.1938 35.5134 20.6012Z",
  fill: "#4C84EE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5134 20.6012V38.2331C35.5134 39.6413 34.3723 40.7824 32.965 40.7824H17.7567V18.0527H32.965C34.3723 18.0527 35.5134 19.1938 35.5134 20.6012Z",
  fill: "#0041BE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0649 30.2481C19.0001 30.2689 18.9561 30.3241 18.9561 30.3849V31.3876C18.9561 32.0505 18.4188 32.5871 17.7567 32.5871C17.0946 32.5871 16.5572 32.0505 16.5572 31.3876V30.3849C16.5572 29.4941 17.021 28.6872 17.7567 28.2298C17.9302 28.1219 18.1189 28.0331 18.3196 27.9676C19.1081 27.7101 19.619 26.9488 19.5615 26.1164C19.4976 25.1905 18.7219 24.438 17.7567 24.438C16.7607 24.438 15.9471 25.243 15.9471 26.2475C15.9471 26.9096 15.4106 27.447 14.7477 27.447C14.0856 27.447 13.5482 26.9096 13.5482 26.2475C13.5482 23.973 15.3884 22.0355 17.7567 22.0391C19.9809 22.0391 21.8044 23.7779 21.9548 25.9517C22.0875 27.8812 20.8993 29.6484 19.0649 30.2481Z",
  fill: "#ECF0F8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0649 30.2481C19.0001 30.2689 18.9562 30.3241 18.9562 30.3849V31.3876C18.9562 32.0505 18.4188 32.587 17.7567 32.587V28.2298C17.9302 28.1219 18.1189 28.0331 18.3197 27.9676C19.1081 27.7101 19.6191 26.9488 19.5615 26.1164C19.4976 25.1905 18.722 24.438 17.7567 24.438V22.0391C19.9809 22.0391 21.8045 23.7779 21.9548 25.9517C22.0875 27.8812 20.8993 29.6484 19.0649 30.2481Z",
  fill: "#AED1F4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9562 35.5256V35.6264C18.9562 36.2885 18.4188 36.8258 17.7567 36.8258C17.0946 36.8258 16.5573 36.2885 16.5573 35.6264V35.5256C16.5573 34.8635 17.0946 34.3262 17.7567 34.3262C18.4188 34.3262 18.9562 34.8635 18.9562 35.5256Z",
  fill: "#ECF0F8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9562 35.5256V35.6264C18.9562 36.2885 18.4188 36.8258 17.7567 36.8258V34.3262C18.4188 34.3262 18.9562 34.8635 18.9562 35.5256Z",
  fill: "#AED1F4"
});

function SvgReset1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset1);
export default __webpack_public_path__ + "static/media/reset1.9b60fa1b.svg";
export { ForwardRef as ReactComponent };